import type { HttpClient } from "../http";
import type {
  WhatsAppMessageDTO,
  WhatsAppOptInDTO,
  UpdateWhatsAppOptInRequest,
  SendWhatsAppTestRequest,
  ParseWhatsAppOrderRequest,
  ParseWhatsAppOrderResponse,
  VoiceCallerContextDTO,
  TopDealsPreviewResponse,
  BroadcastTopDealsRequest,
  BroadcastTopDealsResponse,
  DailyBroadcastPreviewResponse,
  DailyBroadcastResultResponse,
  InteractiveFlowStepResponse,
  WhatsAppConfigDTO,
  UpdateWhatsAppConfigRequest,
} from "../types";

export function whatsappResource(http: HttpClient) {
  return {
    getConfig: () => http.get<WhatsAppConfigDTO>(`/admin/whatsapp/config`),
    updateConfig: (body: UpdateWhatsAppConfigRequest) =>
      http.post<WhatsAppConfigDTO>(`/admin/whatsapp/config`, body),
    getLogs: (limit = 50) => http.get<WhatsAppMessageDTO[]>(`/admin/whatsapp/logs?limit=${limit}`),
    getOptIn: (retailerId: number) => http.get<WhatsAppOptInDTO>(`/admin/whatsapp/opt-in/${retailerId}`),
    updateOptIn: (body: UpdateWhatsAppOptInRequest) => http.post<void>(`/admin/whatsapp/opt-in`, body),
    sendTest: (body: SendWhatsAppTestRequest) => http.post<void>(`/admin/whatsapp/test`, body),
    parseOrder: (body: ParseWhatsAppOrderRequest) =>
      http.post<ParseWhatsAppOrderResponse>(`/admin/whatsapp/parse-order`, body),
    getRateSheet: () => http.get<{ rateSheet: string }>(`/admin/whatsapp/rate-sheet`),
    getTopDeals: (limit = 5, skuIds?: number[]) => {
      const params = new URLSearchParams({ limit: String(limit) });
      if (skuIds && skuIds.length > 0) {
        params.set("skuIds", skuIds.join(","));
      }
      return http.get<TopDealsPreviewResponse>(`/admin/whatsapp/top-deals?${params.toString()}`);
    },
    broadcastDeals: (body?: BroadcastTopDealsRequest) =>
      http.post<BroadcastTopDealsResponse>(`/admin/whatsapp/broadcast-deals`, body ?? {}),
    getDailyBroadcastPreview: (skuIds?: number[]) => {
      const params = new URLSearchParams();
      if (skuIds && skuIds.length > 0) {
        params.set("skuIds", skuIds.join(","));
      }
      const qs = params.toString();
      return http.get<DailyBroadcastPreviewResponse>(
        `/admin/whatsapp/daily-broadcast${qs ? `?${qs}` : ""}`
      );
    },
    broadcastDailyOrders: (body?: { skuIds?: number[] }) =>
      http.post<DailyBroadcastResultResponse>(`/admin/whatsapp/daily-broadcast`, body ?? {}),
    executeInteractiveStep: (body: { retailerId: number; action: string; phone?: string }) =>
      http.post<InteractiveFlowStepResponse>(`/admin/whatsapp/interactive-step`, body),
    getVoiceContext: (phone: string) =>
      http.get<VoiceCallerContextDTO>(`/admin/whatsapp/voice-context/${encodeURIComponent(phone)}`),
  };
}
